import { Component, OnInit, ViewChild } from '@angular/core';
import { BehaviorSubject, from, Observable } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import {
  FormGroup,
  FormBuilder,
  Validators,
  FormsModule,
  ReactiveFormsModule,
  AbstractControl,
  FormArray,
} from '@angular/forms';
import {
  CommonModule,
  NgClass,
  AsyncPipe,
  DatePipe,
  formatDate,
} from '@angular/common';
import { ProfileService } from 'src/app/services/api/consumer/profile.service';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { ToastrService } from 'ngx-toastr';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { DirectivesModule } from 'src/app/directives.module';
import { BookingsTabComponent } from '../bookings-tab/bookings-tab.component';
import { InlineCalendarComponent } from 'src/app/pages/producer/inline-calendar/inline-calendar.component';
import {
  BsDaterangepickerInlineDirective,
  BsDatepickerInputDirective,
  BsDatepickerDirective,
} from 'ngx-bootstrap/datepicker';
import {
  ImageCroppedEvent,
  Dimensions,
  ImageCropperModule,
} from 'ngx-image-cropper';
import {
  NgSelectComponent,
  NgOptionComponent,
  NgOptgroupTemplateDirective,
} from '@ng-select/ng-select';
import { MomentService } from 'src/app/services/api/moment.service';
import moment from 'moment';
import { co, el, s } from '@fullcalendar/core/internal-common';
import { QldProfileCompletionComponent } from '../qld-profile-completion/qld-profile-completion.component';
import { escape, get } from 'lodash';
import { ArticleComponent } from '../../../producer/article/article.component';
import { NgbCalendar, NgbDate, NgbDatepickerModule, NgbModule, NgbDateParserFormatter, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { QuickAvailabilityUpdateComponent } from "../../quick-availability-update/quick-availability-update.component";
import { AuthenticationService } from 'src/app/services/auth/authentication.service';
import { PublicHeaderComponent } from 'src/app/layout/public-header/public-header.component';
import { SafeUrlPipe } from '../safe-url.pipe';
import { VideoPlayerComponent } from '../../../../shared/video-player/video-player.component';

@Component({
  selector: 'app-portfolio',
  standalone: true,
  imports: [
    DirectivesModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    InlineCalendarComponent,
    ImageCropperModule,
    NgbDatepickerModule,
    PublicHeaderComponent,
    VideoPlayerComponent
  ],
  templateUrl: './portfolio.component.html',
  styleUrl: './portfolio.component.scss'
})
export class PortfolioComponent implements OnInit {

  editPersonalInformationForm!: FormGroup;
  editStatusForm!: FormGroup;
  @ViewChild('actionModals') actionModals: any;
  @ViewChild('acceptRequestModal') acceptRequestModal: any;
  @ViewChild('editProfileModal') editProfileModal: any;
  @ViewChild('editStatusModal') editStatusModal: any;
  @ViewChild('editAccreditationModal') editAccreditationModal: any;
  @ViewChild('rightsToWorkModal') rightsToWorkModal: any;
  @ViewChild('skillsModal') skillsModal: any;
  @ViewChild('workExperienceModal') workExperienceModal: any;
  @ViewChild('qualificationsModal') qualificationsModal: any;
  @ViewChild('referenceModal') referenceModal: any;
  @ViewChild('additionalDocumentsModal') additionalDocumentsModal: any;
  @ViewChild('roleTypeModal') roleTypeModal: any;
  @ViewChild('bceQuestionsModal') bceQuestionsModal: any;
  @ViewChild('nswVerificationModal') nswVerificationModal: any;
  @ViewChild('qldVerificationModal') qldVerificationModal: any;
  @ViewChild('hasQCTRegistrationModal') hasQCTRegistrationModal: any;
  @ViewChild('QCTRegistrationFormModal') QCTRegistrationFormModal: any;
  @ViewChild('hasNoQCTRegistrationModal') hasNoQCTRegistrationModal: any;
  @ViewChild('bookingsOnboardingModal') bookingsOnboardingModal: any;
  // Data sources for async pipe

  private invitesSubject = new BehaviorSubject<any[]>([]);
  private historySubject = new BehaviorSubject<any[]>([]);
  invitesSchoolsList = this.invitesSubject.asObservable();
  invitesHistorySchoolsList = this.historySubject.asObservable();
  availability_healthy: any;

  profileData: any;
  historyData: any[] = [];
  schoolDetails: any[] = [];
  selectAllCheck = false;
  hideButton = true;
  activeTab: 'invites' | 'history' = 'invites';
  currentPage = 1;
  currentHistoryPage = 1;
  schoolLengthLimit = 0;
  schoolHistoryLengthLimit = 0;
  submitted = false;
  schoolCount = 0;
  experiance_tree = [];
  fileName: any;
  addFileName: any;
  selectedAdditionalFile: File | null = null;
  // Forms
  declineInviteForm: FormGroup;
  schoolInvitesFilterForm: FormGroup;
  schoolInvitesHistoryFilterForm: FormGroup;
  actionForm: FormGroup;
  editAccreditationForm!: FormGroup;
  rightsToWorkForm!: FormGroup;
  skillsForm!: FormGroup;
  workExperienceForm!: FormGroup;
  qualificationsForm!: FormGroup;
  additionalDocumentsForm!: FormGroup;
  referenceForm!: FormGroup;
  roleTypeForm!: FormGroup;
  QCTRegistrationForm!: FormGroup;
  onboardingStep = 0;
  // Modal state
  actionType: any;
  schoolName: string = '';
  school: any = null;

  // Character count for decline reason
  ShowLenght = 500;
  ShowLenghtError = 500;
  subjectFilter = [];
  selectedFile: File | null = null;
  fileBase64: string | null = null;
  fileBinary: ArrayBuffer | null = null; // Store binary file

  showMainRoleType = true;
  public_profile_show: boolean = false; // For the second switch
  using_cc_to_B: boolean = false; // For the first switch

  notTeacherRoles = [
    'School Administrator',
    'School Principal',
    'HR Manager',
    'School Support Staff',
    'Parent',
    'Student',
    'Education Consultant',
    'Government Official',
    'Recruiter',
    'Other',
  ];
  profileModalData: any;
  qualification_choices: any;
  availability: any;
  all_bce_subjects: any;
  bce_subjects: any;
  expiry_year: any;
  interested_role: any;
  location_preferences: any;
  right_to_work: any;
  roles_interested_in: any;
  subject: any;
  teachingLevels: any;
  CountrySelectorAus: any;
  CountrySelectorNZ: any;
  CountrySelectorSingapore: any;
  countries: any;
  availableStates: any;
  countryStates: any;
  consumer_type_parentTag: any;
  consumer_type_childTag: any;
  consumer_typeStudent: any = [];
  consumer_typeNonTeacher: any = [];
  type_id: string = '';
  showNonTeacherType: boolean = false;
  showUniStudentType: boolean = false;
  parent_role: any;
  hasQCT: any;
  profileInfo: any;
  showOnboarding: boolean = false;
  introVideo: any = null;

  constructor(
    private ProfileService: ProfileService,
    private router: Router,
    private ngxService: NgxUiLoaderService,
    private fb: FormBuilder,
    private modalService: BsModalService,
    public bsModalRef: BsModalRef,
    private toastr: ToastrService,
    private moment: MomentService,
    private authService: AuthenticationService,
    private route: ActivatedRoute
  ) {
    this.declineInviteForm = this.fb.group({});
    this.schoolInvitesFilterForm = this.fb.group({
      filter_name: [''],
      filterType: [''],
      page: [''],
    });
    this.schoolInvitesHistoryFilterForm = this.fb.group({
      filter_name: [''],
      filterType: [''],
      page: [''],
    });
    this.actionForm = this.fb.group({
      action: [''],
      request_id: [''],
      decline_reason: [''],
    });
  }
  // Helper: parse YouTube ID
  private getYouTubeId(url: string): string | null {
    const match = url.match(/(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=|watch\?.+&v=))([\w-]{11})/);
    return match ? match[1] : null;
  }

  // Helper: parse Vimeo ID
  private getVimeoId(url: string): string | null {
    const match = url.match(/(?:vimeo\.com\/(?:video\/)?)(\d+)/);
    return match ? match[1] : null;
  }
  get isAuthenticated(): boolean {
    return this.authService.isLoggedIn();
  }

  ngOnInit(): void {
    this.ngxService.start();
    this.route.paramMap.subscribe(params => {
      const profile = params.get('username');
      console.log(profile);
      if (profile) {
        // Fetch teacher profile by username
        this.ProfileService.profilePortfolioAPI(profile).subscribe({
          next: (res: any) => {
            if (res.status) {
              // Set profileData for template
              this.profileData = res.data;
              console.log(this.profileData);
              // Extract video intro details and set videoMeta for preview
              const videoIntroDetails = this.profileData?.meta?.video_intro_details;
              if (videoIntroDetails?.video_intro_link) {
                const ytId = this.getYouTubeId(videoIntroDetails.video_intro_link);
                if (ytId) {
                  this.introVideo = {
                    type: 'youtube',
                    id: ytId,
                    url: videoIntroDetails.video_intro_link,
                    title: videoIntroDetails.video_intro_title || '',
                    thumbnail: videoIntroDetails.video_intro_thumbnail || '',
                    duration: videoIntroDetails.video_intro_duration || null,
                  };
                } else {
                  // Could add Vimeo support here if needed
                  const vimeoId = this.getVimeoId(videoIntroDetails.video_intro_link);
                  if (vimeoId) {
                    this.introVideo = {
                      type: 'vimeo',
                      id: vimeoId,
                      url: videoIntroDetails.video_intro_link,
                      title: videoIntroDetails.video_intro_title || '',
                      thumbnail: videoIntroDetails.video_intro_thumbnail || '',
                      duration: videoIntroDetails.video_intro_duration || null,
                    };
                  } else {
                    this.introVideo = null;
                  }
                }
              } else {
                this.introVideo = null;
              }

              this.ngxService.stop();
            } else if (!res.status) {
              this.toastr.error(res.message || 'Failed to load profile');
              this.ngxService.stop();
            }
          },
          error: (err: any) => {
            this.toastr.error(err.message || 'Failed to load profile');
            this.ngxService.stop();
          }
        });
      }
    });
  }
  refreshPage() {
    let currentUrl = this.router.url;
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      this.router.navigate([currentUrl]);
    });
  }
  formInIt() {
    this.editPersonalInformationForm = this.fb.group({
      teacher_image: [''],
      firstname: ['', Validators.required],
      lastname: ['', Validators.required],
      // previous_lastname: [''],
      gender: ['', Validators.required],
      country: ['', Validators.required],
      address_state: ['', Validators.required],
      address_streetNumber: ['', Validators.required],
      address_streetName: ['', Validators.required],
      address_city: ['', Validators.required],
      address_postalcode: ['', Validators.required],
      mobilephonenumber: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]],
      emergency_contact_name1: [''],
      emergency_contact_name2: [''],
      emergency_contact_phone1: [''],
      emergency_contact_phone2: [''],
      from: ['profileDetails'],
    });
    this.editStatusForm = this.fb.group({
      status: ['', Validators.required],
      from: 'teacherStatus',
    });

    this.rightsToWorkForm = this.fb.group({
      right_to_work: ['', Validators.required],
      work_start_date: [null],
      from: ['rightToWorkDetails'],
    });
    this.skillsForm = this.fb.group({
      tags: [],
      experiance_tree: [],
      experience_description: [''],
      video_cv: [''],
      from: 'experienceDetails',
    });
    this.workExperienceForm = this.fb.group({
      job_title: ['', Validators.required],
      school_name: ['', Validators.required],
      from_date: ['', Validators.required],
      to_date: ['', Validators.required],
      experience_summary: ['', Validators.required],
      idx: 'workexperience-New',
      from: 'workExperienceDetails',
    });
    this.qualificationsForm = this.fb.group({
      type: ['', Validators.required],
      title: [''],
      institution: [''],
      file: [''],
      from: 'qualificationDetails',
      idx: 'Qualification-New',
    });
    this.additionalDocumentsForm = this.fb.group({
      description: [''],
      name: [''],
      file: ['', Validators.required],
      from: 'additiondocDetails',
      idx: 'AdditionDoc-New',
    });
    this.referenceForm = this.fb.group({
      name: ['', Validators.required],
      email: ['', [Validators.required]],
      phone: [''],
      position: [''],
      org: [''],
      from: 'referenceDetails',
      idx: 'Reference-New',
    });
    this.roleTypeForm = this.fb.group({
      type_id: [''],
      role_type: ['', Validators.required],
      stu_type: [''],
      university: [''],
      passed_year: [''],
      not_teacher_role: [''],
      from: ['consumerType'],
    });
    this.editAccreditationForm = this.fb.group({
      accreditation_name: ['', Validators.required],
      accreditation_id: ['', Validators.required],
      expiry_date: ['', Validators.required],
      idx: ['Accreditation-New'],
      from: ['accreditationDetails'],
    });
    this.QCTRegistrationForm = this.fb.group({
      first_name: ['', Validators.required],
      last_name: ['', Validators.required],
      dob: ['', Validators.required],
      qct_number: ['', Validators.required],
      qld_confirmation: ['', Validators.required],
      qld_verify_consent: ['', Validators.requiredTrue],
      from: ['QCTRegistration'],
    });
  }

  createAccreditationGroup(): FormGroup {
    return this.fb.group({
      accreditation_name: ['', Validators.required],
      accreditation_id: ['', Validators.required],
      expiry_date: ['', Validators.required],
      index: [''],
      from: ['accreditationDetails'],
    });
  }

  get accreditations(): FormArray {
    return this.editAccreditationForm.get('accreditations') as FormArray;
  }

  addAccreditation() {
    this.accreditations.push(this.createAccreditationGroup());
  }

  removeAccreditation(index: number) {
    this.accreditations.removeAt(index);
  }

  setValuesForForms() {
    this.public_profile_show = this.profileData?.meta?.public_profile_show;

    // set blue card and qct id fields
    let blueCardId = this.profileData?.bce_data?.blue_card_id || '';
    // Remove any non-digit characters (like '/')
    blueCardId = blueCardId.replace(/\D/g, '');
    // Now patch each digit
    for (let i = 0; i < 8; i++) {
      this.bceQuestionsForm.patchValue({
        [`blueCard_[${i}]`]: blueCardId[i] || '',
      });
    }
    const qctId = this.profileData?.bce_data?.qct_id || '';
    for (let i = 0; i < 6; i++) {
      this.bceQuestionsForm.patchValue({
        [`qct_[${i}]`]: qctId[i] || '',
      });
    }
    this.bceQuestionsForm.patchValue({
      card_type: this.profileData?.bce_data?.meta?.card_type || '',
      card_holder_name:
        this.profileData?.bce_data?.meta?.card_holder_name || '',
      expiry_date: this.profileData?.bce_data?.meta?.expiry_date || '',
      prefered_location:
        this.profileData?.bce_data?.meta?.prefered_location || '',
      personal_email: this.profileData?.bce_data?.meta?.personal_email || '',
      right_to_work: this.profileData?.bce_data?.meta?.right_to_work || '',
      about_interest: this.profileData?.bce_data?.meta?.about_interest || '',
      bce_roles: this.profileData?.bce_data?.meta?.bce_roles || '',
      interested_role: this.profileData?.bce_data?.meta?.interested_role || [],
      // Safeguarding questions
      negative_notice: this.profileData?.bce_data?.meta?.negative_notice || '',
      suspended_registration:
        this.profileData?.bce_data?.meta?.suspended_registration || '',
      abused: this.profileData?.bce_data?.meta?.abused || '',
      accused: this.profileData?.bce_data?.meta?.accused || '',
      substantiated: this.profileData?.bce_data?.meta?.substantiated || '',
      criminal: this.profileData?.bce_data?.meta?.criminal || '',
      all_questions: this.profileData?.bce_data?.meta?.all_questions || '',
      // Multiple choice
      teachingLevels: this.profileData?.bce_data?.meta?.teachingLevels || [],
      subject: this.profileData?.bce_data?.meta?.subject || [],
    });
  }
  openEditProfileModal() {
    this.bsModalRef = this.modalService.show(this.editProfileModal, {
      class: 'modal-lg',
      backdrop: 'static',
    });
    this.editPersonalInformationForm.patchValue({
      teacher_image: this.profileData?.profile_image || '',
      firstname: this.profileData?.user?.first_name || '',
      lastname: this.profileData?.user?.last_name || '',
      previous_lastname: this.profileData?.meta.previous_lastname || '',
      gender: this.profileData?.meta.gender || '',
      country: this.profileData?.address?.address_timezone.country || '',
      address_state: this.profileData?.address?.address_timezone.state || '',
      address_streetNumber: this.profileData?.address?.locality || '',
      address_streetName: this.profileData?.address?.street || '',
      address_city: this.profileData?.address?.city || '',
      address_postalcode: this.profileData?.address?.postal_code || '',
      mobilephonenumber: this.profileData?.phone || '',
      email: this.profileData?.user?.email || '',
      emergency_contact_name1:
        this.profileData?.meta?.emergency_contact?.emergency_contact_name1 ||
        '',
      emergency_contact_phone1:
        this.profileData?.meta?.emergency_contact?.emergency_contact_phone1 ||
        '',
      emergency_contact_name2:
        this.profileData?.meta?.emergency_contact?.emergency_contact_name2 ||
        '',
      emergency_contact_phone2:
        this.profileData?.meta?.emergency_contact?.emergency_contact_phone2 ||
        '',
      from: 'profileDetails',
    });
  }
  onWorkStartDateChange(date: any) {
    if (!date || date === undefined) {
      this.rightsToWorkForm.patchValue({ work_start_date: null });
      console.log(get(this.rightsToWorkForm.value, 'work_start_date'));
    } else {
      this.rightsToWorkForm.patchValue({ work_start_date: date });
    }
  }
  openEditStatusModal() {
    this.bsModalRef = this.modalService.show(this.editStatusModal, {
      class: 'modal-lg',
      backdrop: 'static',
    });
    this.editStatusForm.patchValue({
      from: 'teacherStatus',
      status: this.profileData?.meta.status || '',
    });
  }

  openEditAccreditationModal(accreditation: any) {
    console.log(accreditation);
    if (accreditation != null && accreditation != '') {
      let idxValue = accreditation.idx || '';
      if (!idxValue.toString().startsWith('Accreditation-') && idxValue !== '') {
        idxValue = 'Accreditation-' + idxValue;
        console.log('Updated idxValue:', idxValue);
      } else if (idxValue === '') {
        idxValue = 'Accreditation-New';
      }
      this.editAccreditationForm.patchValue({
        accreditation_name: accreditation.accreditation_name || '',
        accreditation_id: accreditation.accreditation_id || '',
        expiry_date: this.formatExpiryDate(accreditation.expiry_date) || '',
        idx: idxValue,
        from: 'accreditationDetails',
      });
    } else {
      this.editAccreditationForm.reset({
        accreditation_name: '',
        accreditation_id: '',
        expiry_date: '',
        idx: 'Accreditation-New',
        from: 'accreditationDetails',
      });
    }
    this.bsModalRef = this.modalService.show(this.editAccreditationModal, {
      class: 'modal-lg',
      backdrop: 'static',
    });
  }

  openRightsToWorkModal() {
    this.bsModalRef = this.modalService.show(this.rightsToWorkModal, {
      class: 'modal-lg',
      backdrop: 'static',
    });

    this.rightsToWorkForm.patchValue({
      from: 'rightToWorkDetails',
      right_to_work: this.profileData?.meta.right_to_work || '',
      work_start_date:
        this.toNgbDateStruct(this.profileData?.meta.work_start_date || null),
    });

  }
  // Utility to convert DD/MM/YYYY string to NgbDateStruct
  private toNgbDateStruct(dateStr: string): NgbDateStruct | null {
    if (!dateStr) return null;
    const [day, month, year] = dateStr.split('/').map(Number);
    if (!day || !month || !year) return null;
    return { year, month, day };
  }

  openSkillsModal() {
    this.skillsForm.patchValue({
      tags: this.profileData?.meta.tags || [],
      experiance_tree: this.profileData?.meta.experiance_tree || [],
      experience_description:
        this.profileData?.meta?.experience_description || '',
      video_cv: this.profileData?.work_experience?.video_cv || '',
    });
    this.bsModalRef = this.modalService.show(this.skillsModal, {
      class: 'modal-lg',
      backdrop: 'static',
    });
  }
  openWorkExperienceModal(work_experience: any) {
    // Only patch values if index exists and is not empty
    console.log(work_experience);
    if (work_experience != null && work_experience != '') {
      this.workExperienceForm.patchValue({
        job_title: work_experience.job_title || '',
        school_name: work_experience.school_name || '',
        from_date: this.formatExpiryDate(work_experience.from_date) || '',
        to_date: this.formatExpiryDate(work_experience.to_date) || '',
        experience_summary: work_experience.experience_summary || '',
        idx: 'workexperience-' + work_experience.idx,
        from: 'workExperienceDetails',
      });
    } else {
      // Reset the form for a fresh entry
      this.workExperienceForm.reset({
        job_title: '',
        school_name: '',
        from_date: '',
        to_date: '',
        experience_summary: '',
        idx: 'workexperience-New',
        from: 'workExperienceDetails',
      });
    }
    this.bsModalRef = this.modalService.show(this.workExperienceModal, {
      class: 'modal-lg',
      backdrop: 'static',
    });
  }
  openQualificationsModal(qualification?: any) {
    if (qualification != null && qualification != '') {
      this.qualificationsForm.patchValue({
        type: qualification.type || '',
        title: qualification.title || '',
        institution: qualification.institution || '',
        file: '', // File cannot be set directly, leave empty
        idx: 'Qualification-' + qualification.idx,
        from: 'qualificationDetails',
      });
      this.fileName = false; // Reset file name display
    } else {
      // New entry
      this.qualificationsForm.reset({
        type: '',
        title: '',
        institution: '',
        file: '',
        idx: 'Qualification-New',
        from: 'qualificationDetails',
      });
      this.fileName = false;
    }
    this.bsModalRef = this.modalService.show(this.qualificationsModal, {
      class: 'modal-lg',
      backdrop: 'static',
    });
  }
  openAdditionalDocumentsModal(document?: any) {
    console.log(document);
    if (document != null && document != '') {
      this.additionalDocumentsForm.patchValue({
        name: document.name || '',
        description: document.description || '',
        file: '', // File cannot be set directly, leave empty
        from: 'additiondocDetails',
        idx: 'AdditionDoc-' + document.idx,
      });
      this.addFileName = false; // Reset file name display
    } else {
      // New entry
      this.additionalDocumentsForm.reset({
        name: '',
        description: '',
        file: '',
        idx: 'AdditionDoc-New',
        from: 'additiondocDetails',
      });
      this.addFileName = false;
    }
    this.bsModalRef = this.modalService.show(this.additionalDocumentsModal, {
      class: 'modal-lg',
      backdrop: 'static',
    });
  }
  openReferencesModal(reference?: any) {
    console.log(reference);
    if (reference != null && reference != '') {
      this.referenceForm.patchValue({
        name: reference.name || '',
        email: reference.email || '',
        phone: reference.phone || '',
        position: reference.position || '',
        org: reference.org || '',
        idx: 'Reference-' + reference.idx,
        from: 'referenceDetails',
      });
    } else {
      // New entry
      this.referenceForm.reset({
        name: '',
        email: '',
        phone: '',
        position: '',
        org: '',
        idx: 'Reference-New',
        from: 'referenceDetails',
      });
    }
    this.bsModalRef = this.modalService.show(this.referenceModal, {
      class: 'modal-lg',
      backdrop: 'static',
    });
  }
  openRoleTypeModal() {
    this.bsModalRef = this.modalService.show(this.roleTypeModal, {
      class: 'modal-lg',
      backdrop: 'static',
    });
    const parentTypeId = this.profileData?.consumer_type?.parent_type_id;
    const subTypeId = this.profileData?.consumer_type?.sub_type_id;

    // Find the matching parent tag and its index
    const parentTagIndex = this.consumer_type_parentTag.findIndex(
      (item: any) => item.parent_id == parentTypeId
    );
    const parentTag = this.consumer_type_parentTag[parentTagIndex];


    if (parentTypeId !== undefined && parentTypeId !== null) {
      this.roleTypeForm.patchValue({
        role_type: parentTypeId.toString(),
      });
    } else {
      // Handle the case where parentTypeId is missing
      this.roleTypeForm.patchValue({
        role_type: '',
      });
    }

    if (parentTag && Array.isArray(parentTag.sub_types)) {
      const subType = parentTag.sub_types.find(
        (sub: any) => sub.sub_type_id == subTypeId
      );
      if (subType) {
        // If the matched parentTag is at index 1 (student), set stu_type
        if (parentTagIndex === 1) {
          this.roleTypeForm.patchValue({
            stu_type: subType.sub_type_id,
            role_type: parentTypeId.toString(),
            passed_year: this.profileData?.consumer_type?.passed_year,
            university: this.profileData?.consumer_type?.university,
          });
        } else {
          // For all other parentTag indices, set not_teacher_role
          this.roleTypeForm.patchValue({
            role_type: parentTypeId.toString(),
            not_teacher_role: subType.sub_type_id.toString(),
          });
        }
      }
    }

    this.showMainRoleType = true;
  }
  onStatusInput() {
    const control = this.editStatusForm.get('status');
    if (control && control.value && control.value.length > 140) {
      control.setValue(control.value.substring(0, 140));
    }
  }
  onTabChange(tab: 'invites' | 'history') {
    this.activeTab = tab;
    if (tab === 'invites') {
      this.currentPage = 1;
      this.loadProfileAPI();
    }
  }
  loadProfileAPI() {
    this.ngxService.start();
    this.ProfileService.profilePageAPI().subscribe({
      next: (res: any) => {
        console.log(res);
        if (res.status) {
          this.profileData = res.data.user_data || [];
          this.editPersonalInformationForm.patchValue({
            mobilephonenumber: this.profileData?.phone || '',
            email: this.profileData?.user?.email || '',
          });
          this.using_cc_to_B = this.profileData?.meta?.using_CC_to?.using_cc_to_B;
          this.showOnboarding = this.isOnboardingIncomplete;
          this.ProfileService.setStatus(this.using_cc_to_B);
          // Set showOnboarding based on onboarding completion

          this.profileInfo = res.data || [];
          // this.availability_health = res.data.availability_health;
          this.experiance_tree = res.data.teaching_levels_all || [];
          this.subjectFilter = res.data.subject_tags || [];
          this.qualification_choices = res.data.qualification_choices || [];
          this.all_bce_subjects = res.data.bce_choices?.all_bce_subjects || [];
          this.bce_subjects = res.data.bce_choices?.bce_subjects || [];
          this.expiry_year = res.data.bce_choices?.expiry_year || [];
          this.interested_role = res.data.bce_choices?.interested_role || [];
          this.location_preferences =
            res.data.bce_choices?.prefered_location || [];
          this.right_to_work = res.data.bce_choices?.right_to_work || [];
          this.roles_interested_in = res.data.bce_choices?.bce_roles || [];
          this.subject = res.data.bce_choices?.subject || [];
          this.teachingLevels = res.data.bce_choices?.teachingLevels || [];
          this.countries = res.data.country_states?.countries || [];
          this.countryStates = res.data.country_states || {};
          this.consumer_type_parentTag = res.data.consumer_type || {};
          // After you set this.consumer_type_childTag, add:
          // Filter child tags based on parent_id
          this.consumer_typeStudent = res.data.consumer_type[1].sub_types || [];
          this.consumer_typeNonTeacher =
            res.data.consumer_type[2].sub_types || [];

          // Set Australia as default country if not already set
          if (!this.editPersonalInformationForm.value.country) {
            this.editPersonalInformationForm.patchValue({
              country: 'Australia',
            });
          }
          // Set availableStates to Australia states by default
          this.availableStates = this.countryStates['Australia'] || [];
          this.CountrySelectorAus = res.data.country_states['Australia'] || [];
          this.CountrySelectorNZ = res.data.country_states['New Zealand'] || [];
          this.CountrySelectorSingapore =
            res.data.country_states['Singapore'] || [];
          this.hideButton = true;
          this.setValuesForForms();

          this.ngxService.stop();
        } else {
          this.ngxService.stop();
          this.toastr.error(res.message || 'Failed to load profile');
        }
      },
      error: (err: any) => {
        this.toastr.error(err.message || 'Failed to load profile');
        this.ngxService.stop();
      },
    });
  }

  getFilterInputs() {
    if (this.activeTab === 'invites') {
      this.currentPage = 1;
      this.loadProfileAPI();
    }
  }
  onCountryChange() {
    const selectedCountry = this.editPersonalInformationForm.value.country;
    // Get states for selected country from countryStates
    const states = this.countryStates[selectedCountry] || [];
    // Set the state dropdown options (you may need to bind this to your template)
    this.availableStates = states;
    // Optionally reset the selected state if country changes
    this.editPersonalInformationForm.patchValue({ address_state: '' });
  }
  selectAll(type: any, event: any) {
    const checked = event.target.checked;
    if (type === 'All') {
      this.schoolDetails = [];
      this.profileData.forEach((x: any) => {
        x.isChecked = checked;
        if (checked) {
          this.schoolDetails.push(x);
        }
      });
      this.hideButton = !checked;
    } else {
      type.isChecked = checked;
      if (checked) {
        this.schoolDetails.push(type);
      } else {
        this.schoolDetails = this.schoolDetails.filter((x) => x !== type);
      }
      this.hideButton = this.schoolDetails.length === 0;
    }
    this.selectAllCheck =
      this.profileData.length === this.schoolDetails.length &&
      this.profileData.length > 0;
  }

  accepetRequestModal(action: 'accept' | 'decline') {
    this.actionType = action;
    this.bsModalRef = this.modalService.show(this.acceptRequestModal, {
      class: 'modal-md',
      backdrop: 'static',
    });
  }

  actionModal(school: any, action: 'accept' | 'decline') {
    this.school = school;
    this.schoolName = school.school.title;
    this.actionType = action;
    this.bsModalRef = this.modalService.show(this.actionModals, {
      class: 'modal-md',
      backdrop: 'static',
    });
  }

  getFormControlValues() {
    if (this.actionType == 'accept') {
      this.actionForm.patchValue({
        action: 'accept',
      });
      return this.actionForm.value;
    } else if (this.actionType == 'decline') {
      this.actionForm.patchValue({
        action: 'decline',
      });
      return this.actionForm.value;
    } else {
      return this.declineInviteForm.value;
    }
  }

  checkLength() {
    const timing = this.actionForm.controls['decline_reason'].value || '';
    this.ShowLenght = this.ShowLenghtError - timing.length;
  }

  findNewSchool(): void {
    this.router.navigate(['teacher/find-new-school']);
  }
  goToCalendar() {
    this.router.navigate(['teacher/calendar']);
  }

  bce_work_status: string = 'Y'; // default value

  onPlanningToWorkChange(value: string) {
    this.bce_work_status = value;
    if (value === 'Y') {
      this.bsModalRef = this.modalService.show(this.bceQuestionsModal, {
        class: 'modal-lg',
        backdrop: 'static',
      });
    }
  }

  // Helper function for "DD MMM YYYY" format
  formatDateToDDMMMYYYY(dateStr: string): string {
    if (!dateStr) return '';
    // If already in "DD MMM YYYY" format, return as is
    if (/^\d{2} [A-Za-z]{3} \d{4}$/.test(dateStr)) return dateStr;
    // Otherwise, format using moment
    return moment(dateStr, [
      'DD/MM/YYYY',
      'YYYY-MM-DD',
      'MM/DD/YYYY',
      'DD MMM YYYY',
    ]).format('DD MMM YYYY');
  }

  sendFormValue(from: any): any {
    if (from === 'profileDetails') {
      const formValue = {
        ...this.editPersonalInformationForm.value,
        teacher_image:
          this.croppedImage ||
          this.editPersonalInformationForm.value.teacher_image,
      };
      return formValue;
    } else if (from === 'accreditation') {
      const formValue = { ...this.editAccreditationForm.value };
      formValue.expiry_date = this.formatDateToDDMMMYYYY(formValue.expiry_date);
      // Do not override idx if already set
      if (!formValue.idx || formValue.idx === '') {
        formValue.idx = 'Accreditation-New';
      }
      return formValue;
    } else if (from === 'teacherStatus') {
      const formValue = {
        ...this.editStatusForm.value,
      };
      return formValue;
    } else if (from === 'skills') {
      const formValue = {
        ...this.skillsForm.value,
        tags: this.skillsForm.value.tags || [],
        experiance_tree: this.skillsForm.value.experiance_tree || [],
      };
      return formValue;
    } else if (from === 'workExperience') {
      const fromDate = this.workExperienceForm.value.from_date;
      const toDate = this.workExperienceForm.value.to_date;
      const formValue = {
        ...this.workExperienceForm.value,
        from_date: this.formatDateToDDMMMYYYY(fromDate),
        to_date: this.formatDateToDDMMMYYYY(toDate),
      };
      return formValue;
    } else if (from === 'qualifications') {
      const formValue = { ...this.qualificationsForm.value };
      // Defensive: if type is an array (shouldn't be), use first value
      let typeValue = Array.isArray(formValue.type) ? formValue.type[0] : formValue.type;
      if (formValue.file) {
        const formData = new FormData();
        formData.append('type', typeValue || '');
        formData.append('title', formValue.title || '');
        formData.append('institution', formValue.institution || '');
        formData.append('file', formValue.file, this.fileName || 'document.pdf');
        let idxValue = formValue.idx && formValue.idx.startsWith('Qualification-') && formValue.idx !== 'Qualification-New'
          ? formValue.idx
          : 'Qualification-New';
        formData.append('idx', idxValue);
        formData.append('from', 'qualificationDetails');
        return formData;
      }
      return { ...formValue, type: typeValue };
    } else if (from === 'additionalDocuments') {
      const formValue = { ...this.additionalDocumentsForm.value };
      if (formValue.file) {
        const formData = new FormData();
        formData.append('name', formValue.name || '');
        formData.append('description', formValue.description || '');
        formData.append('file', formValue.file, this.fileName || 'document.pdf');
        // If editing (idx starts with 'AdditionDoc-') and not 'AdditionDoc-New', keep the idx
        let idxValue = formValue.idx && formValue.idx.startsWith('AdditionDoc-') && formValue.idx !== 'AdditionDoc-New'
          ? formValue.idx
          : 'AdditionDoc-New';
        formData.append('idx', idxValue);
        formData.append('from', 'additiondocDetails');
        return formData;
      }
      return formValue;
    } else if (from === 'reference') {
      const formValue = { ...this.referenceForm.value };
      // If editing (idx starts with 'Reference-') and not 'Reference-New', keep the idx
      if (formValue.file) {
        const formData = new FormData();
        formData.append('name', formValue.name || '');
        formData.append('email', formValue.email || '');
        formData.append('phone', formValue.phone || '');
        formData.append('position', formValue.position || '');
        formData.append('org', formValue.org || '');
        let idxValue = formValue.idx && formValue.idx.startsWith('Reference-') && formValue.idx !== 'Reference-New'
          ? formValue.idx
          : 'Reference-New';
        formData.append('idx', idxValue);
        formData.append('from', 'referenceDetails');
        return formData;
      }
      return formValue;
    } else if (from === 'roleType') {
      const roleType = this.roleTypeForm.value.role_type.toString();
      const stuType = this.roleTypeForm.value.stu_type;
      const passed_year = this.roleTypeForm.value.passed_year;
      const university = this.roleTypeForm.value.university;

      const not_teacher_role = this.roleTypeForm.value.not_teacher_role;
      if (roleType === '1') {
        this.roleTypeForm.patchValue({ type_id: [1] });
      } else if (roleType === '2') {
        this.roleTypeForm.patchValue({
          type_id: [roleType, stuType],
          passed_year: passed_year,
          university: university,
        });
      } else if (roleType === '3') {
        this.roleTypeForm.patchValue({
          type_id: [roleType, not_teacher_role],
        });
      }
      this.roleTypeForm.patchValue({ from: 'consumerType' });

      const formValue = {
        ...this.roleTypeForm.value,
      };
      return formValue;
    } else if (from === 'rightsToWork') {
      const dateValue = this.rightsToWorkForm.value.work_start_date;
      let formattedDate = '';
      if (dateValue && typeof dateValue === 'object' && 'year' in dateValue && 'month' in dateValue && 'day' in dateValue) {
        // NgbDateStruct: { year, month, day }
        const day = dateValue.day.toString().padStart(2, '0');
        const month = dateValue.month.toString().padStart(2, '0');
        const year = dateValue.year;
        formattedDate = `${day}/${month}/${year}`;
      } else if (typeof dateValue === 'string' && /^\d{2}\/\d{2}\/\d{4}$/.test(dateValue)) {
        formattedDate = dateValue;
      } else {
        formattedDate = '';
      }
      const formValue = {
        ...this.rightsToWorkForm.value,
        work_start_date: formattedDate,
      };
      return formValue;
    } else if (from === 'bceQuestions') {
      const formValue = { ...this.bceQuestionsForm.value };
      // Format expiry_date only if not already DD/MM/YYYY
      if (
        formValue.expiry_date &&
        !/^\d{2}\/\d{2}\/\d{4}$/.test(formValue.expiry_date)
      ) {
        formValue.expiry_date = this.formatDateToDDMMYYYY(
          formValue.expiry_date
        );
      }
      // If file is a Blob/File, send as FormData
      if (
        formValue.file &&
        typeof formValue.file === 'object' &&
        'size' in formValue.file &&
        'type' in formValue.file
      ) {
        const formData = new FormData();
        Object.keys(formValue).forEach((key) => {
          const value = (formValue as { [key: string]: any })[key];
          if (key === 'file') return;
          if (Array.isArray(value)) {
            formData.append(key, JSON.stringify(value));
          } else {
            formData.append(key, value);
          }
        });
        formData.append(
          'file',
          formValue.file,
          this.bceFileName || 'document.pdf'
        );
        return formData;
      }
      // If file is not a Blob/File, send the link (default patched value)
      return {
        ...formValue,
        file: '',
      };
    }
  }

  private formatExpiryDate(dateStr: string): string {
    if (!dateStr) return '';
    const date = new Date(dateStr);
    if (isNaN(date.getTime())) {
      // Try to parse manually if Date fails
      const parts = dateStr.split(' ');
      if (parts.length === 3) {
        const day = parts[0];
        const month =
          [
            'Jan',
            'Feb',
            'Mar',
            'Apr',
            'May',
            'Jun',
            'Jul',
            'Aug',
            'Sep',
            'Oct',
            'Nov',
            'Dec',
          ].indexOf(parts[1]) + 1;
        const year = parts[2];
        if (month > 0) {
          return `${day.padStart(2, '0')}/${month
            .toString()
            .padStart(2, '0')}/${year}`;
        }
      }
      return '';
    }
    const dd = date.getDate().toString().padStart(2, '0');
    const mm = (date.getMonth() + 1).toString().padStart(2, '0');
    const yyyy = date.getFullYear();
    return `${dd}/${mm}/${yyyy}`;
  }

  formatDateToDDMMYYYY(dateStr: string): string {
    if (!dateStr) return '';
    const date = new Date(dateStr);
    if (isNaN(date.getTime())) return '';
    const dd = date.getDate().toString().padStart(2, '0');
    const mm = (date.getMonth() + 1).toString().padStart(2, '0');
    const yyyy = date.getFullYear();
    return `${dd}/${mm}/${yyyy}`;
  }

  onBookingsChange(event: any) {
    // const checked = (event.target as HTMLInputElement).checked;

    const payload = {
      using_cc_to_B: event.target.checked ? 1 : 0,
      from: 'usingCCToDetails',
    };
    this.ngxService.start();
    this.ProfileService.saveProfileAPI(payload).subscribe({
      next: (res: any) => {
        if (res.status) {
          this.toastr.success(res.message || 'Profile updated successfully');
          this.loadProfileAPI();
        } else {
          this.ngxService.stop();
          this.toastr.error(res.message || 'Failed to update profile');
        }
      },
      error: (err: any) => {
        this.ngxService.stop();
        this.toastr.error(err.message || 'Failed to update profile');
      },
    });
  }
  onPublicProfileShowChange(value: any) {
    const payload = {
      public_profile_show: value.target.checked ? '1' : '0',
      from: 'showPublicprofile',
    };
    this.ngxService.start();
    this.ProfileService.saveProfileAPI(payload).subscribe({
      next: (res: any) => {
        if (res.status) {
          this.toastr.success(res.message || 'Profile updated successfully');
          this.loadProfileAPI();
        } else {
          this.ngxService.stop();
          this.toastr.error(res.message || 'Failed to update profile');
        }
      },
      error: (err: any) => {
        this.ngxService.stop();
        this.toastr.error(err.message || 'Failed to update profile');
      },
    });
  }
  saveProfile(from: any) {
    // Check all required fields in the form being submitted
    let form: FormGroup;
    if (from === 'profileDetails') {
      form = this.editPersonalInformationForm;
    } else if (from === 'accreditation') {
      form = this.editAccreditationForm;
    } else if (from === 'teacherStatus') {
      form = this.editStatusForm;
    } else if (from === 'skills') {
      form = this.skillsForm;
    } else if (from === 'workExperience') {
      form = this.workExperienceForm;
    } else if (from === 'qualifications') {
      form = this.qualificationsForm;
    } else if (from === 'additionalDocuments') {
      form = this.additionalDocumentsForm;
    } else if (from === 'reference') {
      form = this.referenceForm;
    } else if (from === 'roleType') {
      form = this.roleTypeForm;
    } else if (from === 'rightsToWork') {
      form = this.rightsToWorkForm;
    } else if (from === 'roleType') {
      form = this.roleTypeForm;
    } else {
      form = this.editPersonalInformationForm;
    }

    // Mark all controls as touched to show validation errors
    Object.values(form.controls).forEach((control) => {
      control.markAsTouched();
      control.updateValueAndValidity();
    });
    console.log(this.qualificationsForm.value);
    // If form is invalid, show error and stop
    if (form.invalid) {
      this.toastr.error('Please fill all mandatory fields.');
      return;
    }

    if (from === 'accreditation') {
      // Mark all controls as touched to show validation errors
      Object.values(this.editAccreditationForm.controls).forEach((control) => {
        control.markAsTouched();
        control.updateValueAndValidity();
      });

      // If form is invalid, show error and stop
      if (this.editAccreditationForm.invalid) {
        this.toastr.error('Please fill all mandatory accreditation fields.');
        return;
      }
    }
    this.ngxService.start();
    this.ProfileService.saveProfileAPI(this.sendFormValue(from)).subscribe({
      next: (res: any) => {
        if (res.status) {
          this.showMainRoleType = true;
          this.showNonTeacherType = false;
          this.showUniStudentType = false;
          this.bsModalRef.hide();
          this.toastr.success(res.message || 'Profile updated successfully');
          if (this.bsModalRef) {
            this.bsModalRef.hide();
          }
          setTimeout(() => {
            // Ensure modal is closed before opening the next
            this.loadProfileAPI();
          }, 300); // Slightly longer delay to ensure modal is closed
        } else {
          this.ngxService.stop();
          this.toastr.error(res.message || 'Failed to update profile');
        }
      },
      error: (err: any) => {
        this.toastr.error(err.message || 'Failed to update profile');
        this.ngxService.stop();
      },
    });
  }
  imageChangedEvent: any = '';
  croppedImage: any = '';
  school_logo: any = '';
  containWithinAspectRatio = false;
  overview: any;
  fileChangeEvent(event: any): void {
    this.imageChangedEvent = event;
  }
  imageCropped(event: ImageCroppedEvent) {
    this.croppedImage = event.base64;
    // this.school_logo = event.base64;
  }

  showCropper = false;
  imageLoaded() {
    this.showCropper = true;
    // show cropper
  }
  cropperReady(sourceImageDimensions: Dimensions) {
    console.log('Cropper ready', sourceImageDimensions);
    // cropper ready
  }
  loadImageFailed() {
    this.toastr.warning('Upload PNG format images');

    this.croppedImage = '';
    return;
    // show message
  }
  get f(): { [key: string]: AbstractControl } {
    return this.editPersonalInformationForm.controls;
  }
  closeAccreditationModal() {
    this.editAccreditationForm.reset({
      accreditation_name: '',
      accreditation_id: '',
      expiry_date: '',
      idx: 'Accreditation-New',
      from: 'accreditationDetails',
    });
    this.bsModalRef.hide();
  }
  closeModal() {
    this.bsModalRef.hide();
  }
  onShortBioInput() {
    const control = this.skillsForm.get('experience_description');
    if (control && control.value && control.value.length > 300) {
      control.setValue(control.value.substring(0, 300));
    }
  }
  onWorkExperienceInput() {
    const control = this.workExperienceForm.get('about_work');
    if (control && control.value && control.value.length > 300) {
      control.setValue(control.value.substring(0, 300));
    }
  }
  onFileSelected(event: any) {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      this.selectedFile = input.files[0];
      this.fileName = !this.fileName;
      this.fileName = escape(input.files[0].name);
      // if (this.selectedFile.type !== 'application/pdf') {
      //   alert('Only PDF files are allowed!');
      //   this.selectedFile = null;
      //   return;
      // }

      const reader = new FileReader();
      reader.onload = () => {
        const arrayBuffer = reader.result as ArrayBuffer;

        // Convert binary data to Blob
        const blob = new Blob([arrayBuffer], { type: 'application/pdf' });

        // ✅ Store binary (Blob) in FormControlcon
        // console.log(blob)
        this.qualificationsForm.patchValue({ file: blob });
      };
      reader.readAsArrayBuffer(this.selectedFile);
    }
  }
  removeFile(event: any) {
    event.preventDefault();
    const formData = new FormData();
    const fileBlob = this.qualificationsForm.value.file;
    if (fileBlob) {
      formData.delete(fileBlob);
    }
    this.qualificationsForm.patchValue({
      file: '',
    });
    this.fileName = false;
    return;
  }

  onFileSelectedAdditional(event: any) {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      this.selectedAdditionalFile = input.files[0];
      this.addFileName = !this.addFileName;
      this.addFileName = escape(input.files[0].name);
      // if (this.selectedFile.type !== 'application/pdf') {
      //   alert('Only PDF files are allowed!');
      //   this.selectedFile = null;
      //   return;
      // }

      const reader = new FileReader();
      reader.onload = () => {
        const arrayBuffer = reader.result as ArrayBuffer;

        // Convert binary data to Blob
        const blob = new Blob([arrayBuffer], { type: 'application/pdf' });

        // ✅ Store binary (Blob) in FormControlcon
        // console.log(blob)
        this.additionalDocumentsForm.patchValue({ file: blob });
      };
      reader.readAsArrayBuffer(this.selectedAdditionalFile);
    }
  }
  removeAdditionalFile(event: any) {
    event.preventDefault();
    const formData = new FormData();
    const fileBlob = this.additionalDocumentsForm.value.filw;
    if (fileBlob) {
      formData.delete(fileBlob);
    }
    this.additionalDocumentsForm.patchValue({
      file: '',
    });
    this.addFileName = false;
    return;
  }
  onRoleTypeChange(selected: string, id: any) {
    this.roleTypeForm.patchValue({
      role_type: id.toString(),
    });
    if (selected === 'Teacher') {
      this.showMainRoleType = true;
      this.showNonTeacherType = false;
      this.showUniStudentType = false;
    } else if (selected === 'University Student') {
      this.showUniStudentType = true;
      this.showMainRoleType = false;
      this.showNonTeacherType = false;
    } else if (selected === 'Non-teacher') {
      this.showNonTeacherType = true;
      this.showUniStudentType = false;
      this.showMainRoleType = false;
    }
  }
  onRoleTypeBack() {
    this.showMainRoleType = true;
    this.showNonTeacherType = false;
    this.showUniStudentType = false;

    this.roleTypeForm.patchValue({
      role_type: this.profileData?.consumer_type?.parent_type_id.toString(),
    });
  }
  closeRoleTypeModal() {
    this.showMainRoleType = true;
    this.bsModalRef.hide();
  }
  step = 1;
  bceFileName = '';
  safeguardingQuestions = [
    'Have you been issued a negative notice (Blue card)?',
    'Have you ever had your QCT registration or Blue card suspended?',
    'Have you ever abused, exploited or neglected a child or vulnerable adult?',
    'Have you ever been accused of offences relating to a child or vulnerable adult?',
    'Have you ever been the subject of a substantiated complaint, or convicted of an offence relating to a child or vulnerable adult?',
    'Are you currently the subject of a criminal legal proceeding for an offence relating to a child or vulnerable adult?',
    'Are the responses you have provided to these questions true and correct?',
  ];

  subjectsList = [
    /* your subjects array */
  ];

  bceQuestionsForm = this.fb.group({
    'blueCard_[0]': ['', Validators.required],
    'blueCard_[1]': ['', Validators.required],
    'blueCard_[2]': ['', Validators.required],
    'blueCard_[3]': ['', Validators.required],
    'blueCard_[4]': ['', Validators.required],
    'blueCard_[5]': ['', Validators.required],
    'blueCard_[6]': ['', Validators.required],
    'blueCard_[7]': ['', Validators.required],
    'qct_[0]': ['', Validators.required],
    'qct_[1]': ['', Validators.required],
    'qct_[2]': ['', Validators.required],
    'qct_[3]': ['', Validators.required],
    'qct_[4]': ['', Validators.required],
    'qct_[5]': ['', Validators.required],
    bce_work_status: ['N', Validators.required], // default to 'no'
    card_type: ['', Validators.required],
    interested_role: [[], Validators.required],
    // Blue card fields
    card_holder_name: [''],
    // QCT fields
    prefered_location: ['', Validators.required],
    expiry_date: ['', Validators.required],
    personal_email: ['', [Validators.required, Validators.email]],
    right_to_work: ['', Validators.required],
    file: ['', Validators.required],
    about_interest: ['', Validators.required],
    bce_roles: ['', Validators.required],
    // Safeguarding questions
    negative_notice: ['', Validators.required],
    suspended_registration: ['', Validators.required],
    abused: ['', Validators.required],
    accused: ['', Validators.required],
    substantiated: ['', Validators.required],
    criminal: ['', Validators.required],
    all_questions: ['', Validators.required],
    // Multiple choice
    teachingLevels: [[], Validators.required],
    subject: [[], Validators.required],
    from: 'bceQuestions',
  });

  showBceFormError = false;
  missingFieldsError: string = '';
  goToStep(stepNum: number) {
    if (stepNum === 2) {
      let controls = [
        'bce_work_status',
        'card_type',
        ...(this.bceQuestionsForm.value.card_type === 'blueCard'
          ? [
            'blueCard_[0]',
            'blueCard_[1]',
            'blueCard_[2]',
            'blueCard_[3]',
            'blueCard_[4]',
            'blueCard_[5]',
            'blueCard_[6]',
            'blueCard_[7]',
            'card_holder_name',
            'expiry_date',
          ]
          : []),
        ...(this.bceQuestionsForm.value.card_type === 'QCT'
          ? ['qct_[0]', 'qct_[1]', 'qct_[2]', 'qct_[3]', 'qct_[4]', 'qct_[5]']
          : []),
        'prefered_location',
        'personal_email',
        'right_to_work',
        'file',
        'about_interest',
        'bce_roles',
        'interested_role',
      ];

      // Remove 'file' from required controls if bceFileName exists
      if (this.bceFileName) {
        controls = controls.filter((c) => c !== 'file');
      }

      let valid = true;
      let missingFields: string[] = [];
      controls.forEach((controlName) => {
        const control = this.bceQuestionsForm.get(controlName);
        control?.markAsTouched();
        control?.updateValueAndValidity();
        if (!control || control.invalid) {
          valid = false;
          missingFields.push(controlName);
        }
      });

      if (!valid) {
        this.showBceFormError = true;
        this.missingFieldsError = `Please fill all mandatory fields: ${missingFields.join(
          ', '
        )}`;
        this.toastr.error(this.missingFieldsError);
        return;
      }
      this.showBceFormError = false;
      this.missingFieldsError = '';
      this.step = stepNum;
    } else if (stepNum === 3) {
      // Step 2 validation (Safeguarding questions)
      const safeguardControls = [
        'negative_notice',
        'suspended_registration',
        'abused',
        'accused',
        'substantiated',
        'criminal',
        'all_questions',
      ];
      let valid = true;
      let missingFields: string[] = [];
      safeguardControls.forEach((controlName) => {
        const control = this.bceQuestionsForm.get(controlName);
        control?.markAsTouched();
        control?.updateValueAndValidity();
        if (!control || control.invalid) {
          valid = false;
          missingFields.push(controlName);
        }
      });
      if (!valid) {
        this.showBceFormError = true;
        this.missingFieldsError = `Please answer all safeguarding questions: ${missingFields.join(
          ', '
        )}`;
        this.toastr.error(this.missingFieldsError);
        return;
      }
      this.showBceFormError = false;
      this.missingFieldsError = '';
      this.step = stepNum;
    } else {
      this.step = stepNum;
    }
  }

  onBceFileSelected(event: any) {
    const file = event.target.files[0];
    if (file) {
      this.bceFileName = escape(file.name);
      this.bceQuestionsForm.patchValue({ file: file });
    }
  }

  removeBceFile(event: any) {
    this.bceFileName = '';
    this.bceQuestionsForm.patchValue({ file: '' });
  }
  submitBceQuestions() {
    if (this.bceQuestionsForm.value.bce_work_status === 'N') {
      var data = {
        bce_work_status: 'N',
        from: 'bceQuestions',
      };
      this.ngxService.start();
      this.ProfileService.saveBCEProfileAPI(data).subscribe({
        next: (res: any) => {
          if (res.status) {
            this.bsModalRef.hide();
            this.toastr.success(res.message || 'Profile updated successfully');
            this.loadProfileAPI();
          } else {
            this.ngxService.stop();
            this.toastr.error(res.message || 'Failed to update profile');
          }
        },
        error: (err: any) => {
          this.toastr.error(err.message || 'Failed to update profile');
          this.ngxService.stop();
        },
      });
    }
    // Only validate if bce_work_status is 'yes' and on step 3
    if (
      this.bceQuestionsForm.value.bce_work_status === 'Y' &&
      this.step === 3
    ) {
      const controls = ['teachingLevels', 'subject'];
      let valid = true;
      let missingFields: string[] = [];
      controls.forEach((controlName) => {
        const control = this.bceQuestionsForm.get(controlName);
        control?.markAsTouched();
        control?.updateValueAndValidity();
        if (!control || control.invalid) {
          valid = false;
          missingFields.push(controlName);
        }
      });
      if (!valid) {
        this.showBceFormError = true;
        this.missingFieldsError = `Please fill all mandatory fields: ${missingFields.join(
          ', '
        )}`;
        this.toastr.error(this.missingFieldsError);

        return;
      } else {
        this.ngxService.start();

        this.ProfileService.saveBCEProfileAPI(
          this.sendFormValue('bceQuestions')
        ).subscribe({
          next: (res: any) => {
            if (res.status) {
              this.bsModalRef.hide();
              this.toastr.success(res.message || 'Profile loaded successfully');
              this.loadProfileAPI();
            } else {
              this.ngxService.stop();
              this.toastr.error(res.message || 'Failed to load profile');
            }
          },
          error: (err: any) => {
            this.toastr.error(err.message || 'Failed to load profile');
            this.ngxService.stop();
          },
        });
        // Submit the form (API call or further logic)
        // Example:
        // this.ProfileService.submitBceQuestions(this.bceQuestionsForm.value).subscribe(...);

        this.bsModalRef.hide();
      }
      this.showBceFormError = false;
      this.missingFieldsError = '';
    }
  }

  days = Array.from({ length: 31 }, (_, i) =>
    (i + 1).toString().padStart(2, '0')
  );
  months = Array.from({ length: 12 }, (_, i) =>
    (i + 1).toString().padStart(2, '0')
  );
  years = Array.from({ length: 50 }, (_, i) =>
    (new Date().getFullYear() - i).toString()
  );

  onCardTypeChange(type: string) {
    this.bceQuestionsForm.patchValue({ card_type: type });
    // Optionally reset related fields
    if (type === 'blueCard') {
      let blueCardId = this.profileData?.bce_data?.blue_card_id || '';
      // Remove any non-digit characters (like '/')
      blueCardId = blueCardId.replace(/\D/g, '');
      // Now patch each digit
      for (let i = 0; i < 8; i++) {
        this.bceQuestionsForm.patchValue({
          [`blueCard_[${i}]`]: blueCardId[i] || '',
        });
      }
    } else if (type === 'QCT') {
      const qctId = this.profileData?.bce_data?.qct_id || '';
      for (let i = 0; i < 6; i++) {
        this.bceQuestionsForm.patchValue({
          [`qct_[${i}]`]: qctId[i] || '',
        });
      }
    }
  }
  blueCardBoxes = Array(7); // For 7 digits
  qctBoxes = Array(6); // For 6 digits

  onBlueCardDigitInput(event: any, index: number) {
    const input = event.target;
    const value = input.value;
    if (value && value.length === 1 && index < 7) {
      // Move to next box
      console.log('blueCard_' + '[' + (index + 1) + ']');

      const nextInput = document.getElementById(
        'blueCard_' + '[' + (index + 1) + ']'
      );
      if (nextInput) {
        (nextInput as HTMLInputElement).focus();
      }
    }
    // Optionally, handle backspace to move to previous box
    if (event.inputType === 'deleteContentBackward' && !value && index > 0) {
      const prevInput = document.getElementById(
        'blueCard_' + '[' + (index - 1) + ']'
      );
      if (prevInput) {
        (prevInput as HTMLInputElement).focus();
      }
    }
  }
  onQctDigitInput(event: any, index: number) {
    const input = event.target;
    const value = input.value;
    if (value && value.length === 1 && index < 5) {
      // Move to next box
      const nextInput = document.getElementById(
        'qct_' + '[' + (index + 1) + ']'
      );
      if (nextInput) {
        (nextInput as HTMLInputElement).focus();
      }
    }
    // Optionally, handle backspace to move to previous box
    if (event.inputType === 'deleteContentBackward' && !value && index > 0) {
      const prevInput = document.getElementById(
        'qct_' + '[' + (index - 1) + ']'
      );
      if (prevInput) {
        (prevInput as HTMLInputElement).focus();
      }
    }
  }
  openBceModal(value: 'Y' | 'N', from: '' | 'modal') {
    this.bce_work_status = value;

    if (from === 'modal') {
      return;
    } else {
      // Patch initial values from profileData if available
      this.bceFileName = this.profileData?.bce_data?.file_name;

      // set blue card and qct id fields

      let blueCardId = this.profileData?.bce_data?.blue_card_id || '';
      // Remove any non-digit characters (like '/')
      blueCardId = blueCardId.replace(/\D/g, '');
      // Now patch each digit
      for (let i = 0; i < 8; i++) {
        this.bceQuestionsForm.patchValue({
          [`blueCard_[${i}]`]: blueCardId[i] || '',
        });
      }
      const qctId = this.profileData?.bce_data?.qct_id || '';
      for (let i = 0; i < 6; i++) {
        this.bceQuestionsForm.patchValue({
          [`qct_[${i}]`]: qctId[i] || '',
        });
      }
      this.bceQuestionsForm.patchValue({
        bce_work_status: value,
        card_type: this.profileData?.bce_data?.meta?.card_type || '',
        card_holder_name:
          this.profileData?.bce_data?.meta?.card_holder_name || '',
        expiry_date: this.profileData?.bce_data?.meta?.expiry_date || '',
        prefered_location:
          this.profileData?.bce_data?.meta?.prefered_location || '',
        personal_email: this.profileData?.bce_data?.meta?.personal_email || '',
        right_to_work: this.profileData?.bce_data?.meta?.right_to_work || '',
        about_interest: this.profileData?.bce_data?.meta?.about_interest || '',
        bce_roles: this.profileData?.bce_data?.meta?.bce_roles || '',
        interested_role:
          this.profileData?.bce_data?.meta?.interested_role || [],
        // Safeguarding questions
        negative_notice:
          this.profileData?.bce_data?.meta?.negative_notice || '',
        suspended_registration:
          this.profileData?.bce_data?.meta?.suspended_registration || '',
        abused: this.profileData?.bce_data?.meta?.abused || '',
        accused: this.profileData?.bce_data?.meta?.accused || '',
        substantiated: this.profileData?.bce_data?.meta?.substantiated || '',
        criminal: this.profileData?.bce_data?.meta?.criminal || '',
        all_questions: this.profileData?.bce_data?.meta?.all_questions || '',
        // Multiple choice
        teachingLevels: this.profileData?.bce_data?.meta?.teachingLevels || [],
        subject: this.profileData?.bce_data?.meta?.subject || [],
      });
      this.bsModalRef = this.modalService.show(this.bceQuestionsModal, {
        class: 'modal-lg',
        backdrop: 'static',
      });
      this.step = 1; // Always start at step 1
    }
  }
  openNSWVerificationModal() {
    this.bsModalRef = this.modalService.show(this.nswVerificationModal, {
      class: 'modal-md',
      backdrop: 'static',
    });
  }

  openQLDVerificationModal(status: 'NM' | 'E') {
    // if(status === 'E' || status === 'NM'){
    //   this.QCTRegistrationForm.patchValue({
    //     qld_verification: status,
    //   });
    // }
    this.bsModalRef = this.modalService.show(this.qldVerificationModal, {
      class: 'modal-md',
      backdrop: 'static',
    });
  }

  submitQLD(response: 'Yes' | 'No') {
    if (response === 'No') {
      this.bsModalRef.hide();
    } else if (response === 'Yes') {
      this.bsModalRef.hide();
      this.bsModalRef = this.modalService.show(this.hasQCTRegistrationModal, {
        class: 'modal-lg',
        backdrop: 'static',
      });
    }
  }
  submitHasQCTRegistration() {
    if (this.hasQCT == undefined) {
      this.toastr.error('Please select an option to proceed.');
      return;
    }
    this.bsModalRef.hide();
    const modal = this.hasQCT == 'Yes'
      ? this.QCTRegistrationFormModal
      : this.hasNoQCTRegistrationModal;
    this.bsModalRef = this.modalService.show(modal, {
      class: 'modal-md',
      backdrop: 'static',
    });
  }

  submitQLDNoQCT() {
    this.bsModalRef.hide();
  }

  submitHasQCTRegistrationForm() {
    if (this.QCTRegistrationForm.invalid) {
      this.QCTRegistrationForm.markAllAsTouched();
      return;
    } else {
      this.ngxService.start();
      this.QCTRegistrationForm.patchValue({
        dob: new DatePipe('en-US').transform(this.QCTRegistrationForm.value.dob, 'dd/MM/YYYY'),
      });
      this.ProfileService.qldVerificationAPI(this.QCTRegistrationForm.value).subscribe({
        next: (res: any) => {
          this.bsModalRef.hide();
          this.ngxService.stop();
          this.toastr[res.status ? 'success' : 'error'](
            res.message || (res.status
              ? 'QCT Registration form submitted successfully'
              : 'Failed to submit QCT Registration form')
          );
          this.loadProfileAPI();
        },
        error: () => {
          this.toastr.error('Failed to submit QCT Registration form');
          this.ngxService.stop();
        },
      });
    }
  }

  // Simple helper to check error visibility
  isInvalid(controlName: string): boolean {
    const control = this.QCTRegistrationForm.get(controlName);
    return !!(control && control.invalid && (control.dirty || control.touched));
  }


  submitNSW(response: 'Yes' | 'No') {
    var data = {
      nsw_verification: response,
      from: 'nswVerification',
    };
    this.ngxService.start();
    this.ProfileService.saveProfileAPI(data).subscribe({
      next: (res: any) => {
        if (res.status) {
          this.bsModalRef.hide();
          this.toastr.success(res.message || 'Profile updated successfully');
          this.loadProfileAPI();
        } else {
          this.ngxService.stop();
          this.toastr.error(res.message || 'Failed to update profile');
        }
      },
      error: (err: any) => {
        this.toastr.error(err.message || 'Failed to update profile');
        this.ngxService.stop();
      },
    });
  }
  // goToPreviousStep() {
  //   if (this.onboardingStep > 1) {
  //     this.onboardingStep--;
  //     this.openStepModal(this.onboardingStep);
  //   }
  // }

  goToNextStep() {
    if (this.bsModalRef) {
      this.bsModalRef.hide();
    }
    setTimeout(() => {
      this.openNextIncompleteModal();
    }, 300);
  }
  openNextIncompleteModal() {
    const mandatory = this.profileData?.percentage_mandatory || {};
    if (!mandatory.using_cc_to_mandatory) {
      this.openBookingsOnboardingModal();
      return;
    }
    if (!mandatory.personal_detail_mandatory) {
      this.openEditProfileModal();
      return;
    }
    if (!mandatory.consumer_type_mandatory) {
      this.openRoleTypeModal();
      return;
    }
    if (!mandatory.right_to_work_mandatory) {
      this.openRightsToWorkModal();
      return;
    }
    if (!mandatory.experience_mandatory) {
      this.openSkillsModal();
      return;
    }
    if (!mandatory.qualifications) {
      this.openQualificationsModal();
      return;
    }
    if (!mandatory.references) {
      this.openReferencesModal();
      return;
    }
    // All steps completed, do not open any modal

  }
  getYearsList(): number[] {
    return Array.from({ length: 15 }, (_, i) => 2023 + i); // [2010, 2011, ..., 2024]
  }

  handleChildEvent(data: string) {
    console.log('Received from child:', data);
    this.loadProfileAPI();
  }


  openBookingsOnboardingModal() {
    this.bsModalRef = this.modalService.show(this.bookingsOnboardingModal, {
      class: 'modal-md',
      backdrop: 'static',
    });
  }

  getNextOnboardingStep(): number {
    if (!this.using_cc_to_B && this.using_cc_to_B !== undefined) {
      this.showOnboarding = false; // Onboarding skipped
      return 0; // Onboarding skipped
    }
    const mandatory = this.profileData?.percentage_mandatory || {};
    if (!mandatory.using_cc_to_mandatory) return 1;
    if (!mandatory.personal_detail_mandatory || !mandatory.consumer_type_mandatory || !mandatory.right_to_work_mandatory) return 2;
    if (!mandatory.experience_mandatory) return 3;
    if (!mandatory.qualifications) return 4;
    if (!mandatory.references) return 5;
    return 6; // All completed
  }
  get isOnboardingIncomplete(): boolean {
    if (!this.using_cc_to_B && this.using_cc_to_B !== undefined) {
      this.showOnboarding = false;
      return false; // Onboarding skipped
    }
    const mandatory = this.profileData?.percentage_mandatory || {};
    return (
      !mandatory.using_cc_to_mandatory ||
      !mandatory.personal_detail_mandatory ||
      !mandatory.consumer_type_mandatory ||
      !mandatory.right_to_work_mandatory ||
      !mandatory.experience_mandatory ||
      !mandatory.qualifications ||
      !mandatory.references
    );
  }
  openOnboardingStep(step: number) {
    if (this.bsModalRef) {
      this.bsModalRef.hide();
    }
    setTimeout(() => {
      this.onboardingStep = step;
      switch (step) {
        case 1:
          this.bsModalRef = this.modalService.show(this.bookingsOnboardingModal, {
            class: 'modal-md',
            backdrop: 'static',
          });
          break;
        case 2:
          const mandatory = this.profileData?.percentage_mandatory || {};
          if (!mandatory.personal_detail_mandatory) {
            this.bsModalRef = this.modalService.show(this.editProfileModal, { class: 'modal-lg', backdrop: 'static' });
          } else if (!mandatory.consumer_type_mandatory) {
            this.bsModalRef = this.modalService.show(this.roleTypeModal, { class: 'modal-lg', backdrop: 'static' });
          } else if (!mandatory.right_to_work_mandatory) {
            this.bsModalRef = this.modalService.show(this.rightsToWorkModal, { class: 'modal-lg', backdrop: 'static' });
          }
          break;
        case 3:
          this.bsModalRef = this.modalService.show(this.skillsModal, { class: 'modal-lg', backdrop: 'static' });
          break;
        case 4:
          this.bsModalRef = this.modalService.show(this.qualificationsModal, { class: 'modal-lg', backdrop: 'static' });
          break;
        case 5:
          this.bsModalRef = this.modalService.show(this.referenceModal, { class: 'modal-lg', backdrop: 'static' });
          break;
      }
    }, 300); // 300ms delay for modal animation
  }

  // Open the correct modal for the step
  triggerOnboardingFlow() {
    const step = this.getNextOnboardingStep();
    if (step > 0) {
      this.openOnboardingStep(step);
    }
  }
  closeBookingsAndContinue() {
    if (this.bsModalRef) {
      this.bsModalRef.hide();
    }
    setTimeout(() => {
      this.triggerOnboardingFlow();
    }, 300); // Delay ensures modal is closed before next opens
  }
  saveBookingsOnboarding() {
    const payload = {
      using_cc_to_B: this.using_cc_to_B ? 1 : 0,
      from: 'usingCCToDetails',
    };

    this.ngxService.start();
    this.ProfileService.saveProfileAPI(payload).subscribe({
      next: (res: any) => {
        if (res.status) {
          this.toastr.success(res.message || 'Profile updated successfully');
          if (this.bsModalRef) {
            this.bsModalRef.hide();
          }

          // If bookings are OFF, skip onboarding and mark as completed
          if (!this.using_cc_to_B) {
            this.showOnboarding = false; // Hide onboarding UI
            this.onboardingStep = 0;     // Reset step
            this.ngxService.stop();
            // Optionally, set a flag in backend/profile to mark onboarding as completed
            return; // Do not trigger onboarding flow
          }

          // If bookings are ON, continue onboarding as usual
          this.onboardingStep = 1;
          setTimeout(() => {
            this.loadProfileAPI();
          }, 300);
        } else {
          this.ngxService.stop();
          this.toastr.error(res.message || 'Failed to update profile');
        }
      },
      error: (err: any) => {
        this.ngxService.stop();
        this.toastr.error(err.message || 'Failed to update profile');
      },
    });
  }
  handlePageData(data: any) {
    // Store the page data for later use, e.g. pagination or display
    this.pageData = data;
    // Optionally, update the UI or trigger other logic if needed
    // Example: this.obsArray.next(data.consumer_list || []);
  }
  pageData: any;
  onDateInputKeyDown(event: KeyboardEvent, datepicker: any) {
    if (event.key === 'Enter') {
      datepicker.toggle();
      event.preventDefault();
    }
  }
  clearSinglePicker() {
    this.rightsToWorkForm.patchValue({
      work_start_date: null
    });
  }
  /**
 * Remove a row (qualification, attachment, reference, accreditation, workexperience, skills)
 * @param type remove_qualification, remove_attachments, remove_references, remove_accreditation, remove_workexperience, remove_skills
 * @param index index of the item to remove
 */
  removeRow(type: string, index: number) {
    const payload = { remove: type, index };
    this.ngxService.start();
    this.ProfileService.profileDeleteAPI(payload).subscribe({
      next: (res: any) => {
        if (res.status) {
          this.toastr.success(res.message || 'Removed successfully');
          this.loadProfileAPI();
        } else {
          this.toastr.error(res.message || 'Failed to remove');
        }
        this.ngxService.stop();
      },
      error: (err: any) => {
        this.toastr.error(err.message || 'Failed to remove');
        this.ngxService.stop();
      },
    });
  }
}
